import React, { useEffect, useRef, useCallback } from 'react';
import gsap from 'gsap';

import useMediaStore from '../../../../../common/store/useMediaStore';

const useAnimation = (
  wrapper: React.RefObject<HTMLDivElement>,
  info: React.RefObject<HTMLDivElement>[],
  active: boolean
) => {
  const doms = useRef<HTMLDivElement[]>([]);

  const md = useMediaStore(useCallback(state => state.md, []));
  const lg = useMediaStore(useCallback(state => state.lg, []));

  function animate(type: "expand" | "collapse", immediate: boolean) {
    const defaults = {
      duration: immediate ? 0.1 : 0.75,
      ease: "power2.out",
      stagger: 0.1,
      overwrite: true
    };

    const props = {
      wrapper: {
        height: type === "collapse" ? 0 : lg ? "230rem" : md ? "250rem" : "300rem"
      },
      info: {
        y: type === "collapse" ? 0 : -50,
        opacity: type === "collapse" ? 0 : 1
      }
    };

    gsap.to(wrapper.current, {
      ...defaults,
      ...props.wrapper
    });

    gsap.to([doms.current], {
      ...defaults,
      ...props.info
    });
  }

  useEffect(() => {
    info.forEach(ref => ref.current && doms.current.push(ref.current));

    return () => { doms.current.length = 0 }
  }, []);

  useEffect(() => {
    animate(active ? "expand" : "collapse", true);
  }, [lg, md]);

  useEffect(() => {
    animate(active ? "expand" : "collapse", false);
  }, [active]);
}

export default useAnimation;
